<template>
	<div class="layout layout--small layout--top">
		<div class="layout__item u-5/24-default u-5/24-palm hide-on-sticky">
			<template v-if="resultItem.TariffVariation">
				<h6 class="u-weight--normal">{{resultItem.TariffVariation.Text}}</h6>
				<div class="zeta u-weight--bold">{{resultItem.TariffVariation.Value}}</div>
			</template>
		</div>
		<div class="layout__item u-5/24-default u-6/24 u-8/24-palm hide-on-sticky">
			<template v-if="resultItem.Duration">
				<h6 class="u-weight--normal">{{resultItem.Duration.Text}}</h6>
				<div v-tooltip="resultItem.Duration.ToolTip" class="zeta u-weight--bold">
					<span
						:class="{'u-text-decoration--dashed-underline':resultItem.Duration.ToolTip}"
					>{{resultItem.Duration.Value}} {{resultItem.Duration.Unit}}</span>
				</div>
			</template>
		</div>
		<div class="layout__item u-7/24-default u-11/24-palm hide-on-sticky">
			<template v-if="resultItem.Origin">
				<h6 class="u-weight--normal">
					{{resultItem.Origin.Text}}
					<span
						class="u-position--absolute ml-- u-text-color-status--green small"
					>
						<svg width="15" height="20" viewBox="0 0 15 20" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12.18 0s-1.645 1.596-3.424 2.24c-13.179 4.767-7.621 14.056-7.44 14.087 0 0 .74-1.287 1.738-2.021 6.334-4.657 7.622-10.017 7.622-10.017s-1.422 6.45-7.057 10.463C2.374 15.638 1.53 17.82 1.174 20c0 0 .883-.356 1.262-.453.148-.966.457-1.89.98-2.716 7.877.938 10.457-5.409 10.794-7.622C15.005 3.982 12.18 0 12.18 0z"
								fill="#FFF"
								class="u-svg-fill"
							/>
						</svg>
					</span>
				</h6>
				<div class="zeta u-weight--bold" v-if="resultItem.Origin">{{resultItem.Origin.Value}}</div>
			</template>
		</div>
		<div class="layout__item u-2/24-default portable-visuallyhidden lap-visuallyhidden"></div>
		<div class="layout__item u-5/24-default u-6/24-lap u-1/1-palm u-text-align--right palm-pt0">
			<a
				v-if="resultItem.RegistrationFormLink"
				rel="noopener"
				class="c-button c-button--cta c-button--fullwidth mb0 c-button--large-text"
				target="_blank"
				@click="showForm(resultItem, 'Top block')"
			>{{resultItem.RegistrationFormLink.Text}}</a>
			<a
				v-if="!resultItem.RegistrationFormLink"
				class="c-button c-button--disabled c-button--fullwidth c-button--large-text mb0"
				v-tooltip="'Helaas maakt deze leverancier geen gebruik van de mogelijkheid om dit aanbod direct via ons af te laten sluiten. Bekijk vergelijkbare deals en profiteer van onze hulp en gratis overstapservice.'"
				target="_blank"
			>Aanmelden</a>
		</div>
		<div class="layout__item u-1/1 u-text-align--left hide-on-sticky">
			<div class="c-tag c-tag--blue mt u-text-align--center" v-if="resultItem.IsUrgent">
				<span
					v-tooltip="'Bij een spoedaanvraag kan de levering gestart worden binnen de wettelijke bedenktermijn van 14 dagen. Dit kan noodzakelijk zijn wanneer u de sleutel van uw nieuwe woning al heeft ontvangen of binnenkort ontvangt en u al een brief van de netbeheerder heeft ontvangen dat u met spoed een energiecontract moet afsluiten.</p>De levering gaat dan zo spoedig mogelijk na uw aanmelding van start of op de door u opgegeven datum van sleuteloverdracht. Mocht u zich binnen de bedenktermijn toch bedenken en de aanvraag annuleren, dan wordt de geleverde energie binnen de bedenktermijn in rekening gebracht volgens de afgesproken tarieven.'"
				>Spoedaanvraag mogelijk bij verhuizing</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['resultItem']
};
</script>

<style>
</style>
